// Note: Please update  src/styles/utilities/media-queries.scss if new breakpoint is added here.
export const ScreenWidthBreakpoints = {
    xsmall: '(max-width: 414px)',
    small:  '(max-width: 600px)',
    medium: '(max-width: 768px)',
    large: '(max-width: 992px)',
    xlarge: '(max-width: 1200px)'
 };
